import React from 'react';
import { Typography } from '../../../atoms/typography/Typography';
import { LinkButton } from '../../../atoms/linkButton/LinkButton';

const ArticleHelperBox = ({
  title,
  subtitle,
  button1Label,
  button2Label,
  button1Href,
  button2Href,
}) => (
  <div className="flex flex-col w-full justify-center items-center bg-primary-50 p-10 md:p-20 rounded-2xl gap-5 xl:my-10">
    <Typography
      as={'h2'}
      fontVariant={'h8'}
      className={'text-primary-800 max-w-xs'}
    >
      {title}
    </Typography>
    <Typography fontVariant={'sm'} className={'text-primary-800 max-w-lg'}>
      {subtitle}
    </Typography>
    {(button1Label || button2Label) && (
      <div className="flex flex-col md:flex-row gap-5">
        {button1Label && (
          <LinkButton
            external={true}
            href={button1Href}
            label={button1Label}
            className={'bg-primary-100 !text-primary-800'}
          />
        )}

        {button2Label && (
          <LinkButton
            href={button2Href}
            label={button2Label}
            className={'bg-primary-100 !text-primary-800'}
          />
        )}
      </div>
    )}
  </div>
);

export default ArticleHelperBox;
